module.exports = __webpack_public_path__ + "static/media/to-bottom.3c44f112.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/to-bottom.svg
// module id = 2328
// module chunks = 0